/**
 * @author Rejo Varghese
 * @description Deman days table module
 */
import React  from 'react';
import {Typography, Button} from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { postCall } from '../../../utils/network.util';
import { UPDATE_DEMAND_DAY_URL } from '../../../utils/api-url';
import {  getDateInReadableFormat } from '../../../utils/dates-util';

const {Text} = Typography;

export const getDemandDaysColumns=(onEdit)=>{

  const demandColumns =[
    { 
      title: 'Sl No.',
      dataIndex: 'id',
      width: '10%',
      render: (text,record,index)=> (<Text>{index+1}</Text>)
    },
    {
        title: 'ORIGIN',
        dataIndex: 'origin_city',
        key: 'origin_city',
        // filters:origins,
        // onFilter: (value, record) => record.origin_city.indexOf(value) === 0,
      },
      {
        title: 'DESTINATION',
        dataIndex: 'destination_city',
        key: 'destination_city',
        // filters : destinations,
        // onFilter: (value, record) => record.destination_city.indexOf(value) === 0,
      },
      {
        title: 'Date',
        dataIndex: 'demand_date',
        key: 'demand_date',
        render: (text, record) => (
          <Text>{getDateInReadableFormat(record.demand_date, true, true)}</Text>
        )
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description'
      },
      {
        title: 'Action',
        key: 'action',
        width: '10%',
        render: (text, record) => (
          <Button 
            type="primary" 
            icon={<EditOutlined />}
            onClick={() => onEdit(record)}
          >
            Edit
          </Button>
        )
      }
];

return demandColumns;

}



export const updateDemandDay = (id, description) => {
    return new Promise((succeed, fail) => {
        const payload = {
            id: id,
            description: description
        };
        
        postCall(UPDATE_DEMAND_DAY_URL, payload)
            .then(response => {
                if (response.status) {
                    succeed(response.payload);
                } else {
                    fail(response.error);
                }
            })
            .catch(error => {
                fail(error);
            });
    });
};
